import { render, staticRenderFns } from "./Sparkline.vue?vue&type=template&id=286a664a&scoped=true"
import script from "./Sparkline.vue?vue&type=script&lang=js"
export * from "./Sparkline.vue?vue&type=script&lang=js"
import style0 from "./Sparkline.vue?vue&type=style&index=0&id=286a664a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286a664a",
  null
  
)

export default component.exports